import { skipSlideAttributeKey } from './skip-slide.actions'

/**
 * Plugin that subscribes to slide-attributes/updateAttributes mutation
 * and commits setSkipSlideById when skipSlide attribute is updated
 */
const skipSlideAttributePlugin = (store) => {
  store.subscribe((mutation) => {
    // Only listen to the updateAttributes mutation from slide-attributes module
    if (mutation.type !== 'slideAttributes/updateAttributes') return

    const { slideId, attributes } = mutation.payload

    // Check if the mutation contains skipSlide attribute
    if (attributes && Object.prototype.hasOwnProperty.call(attributes, skipSlideAttributeKey)) {
      // Commit setSkipSlideById to the skip-slide module
      store.commit('skipSlide/setSkipSlideById', {
        id: slideId,
        value: attributes[skipSlideAttributeKey],
      })
    }
  })
}

export default skipSlideAttributePlugin
